import { RouteRecordRaw } from "vue-router";
const routes: RouteRecordRaw[] = [
  {
    path: "manualAuthorization",
    name: "manualAuthorization",
    component: () => import("@/views/manual-authorization/index.vue")
  }
];
export default routes;
